import { Stack } from '@mui/material'

import { IframeProps } from './types'

export const Iframe = ({ height, src }: IframeProps): JSX.Element => (
  <Stack
    alignItems='center'
    direction='row'
    sx={{
      '& iframe': {
        border: 'none',
        minHeight: `${height}px`,
        width: '100%',
      },
      pt: 2,
      px: 2,
    }}
  >
    <iframe src={src}></iframe>
  </Stack>
)
